import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import { SALES_ORDER_SEARCH_ENDPOINT } from '../../config/api';
import { decryptData } from '../../utils/encrypt';
import SalesOrderCard from './cards/SalesOrderCard';
import SalesOrderTable from './cards/SalesOrderTable'; 

function SalesOrderSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [viewMode, setViewMode] = useState('card'); 
  const navigate = useNavigate();

  useEffect(() => {
    const today = new Date();
    const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1);
    setFromDate(twoMonthsAgo.toISOString().split('T')[0]);
    setToDate(today.toISOString().split('T')[0]);
  }, []);

  const handleSearch = async () => {
    try {
      const encrypted = localStorage.getItem('suyog_user');
      if (!encrypted) return alert('Login required');

      const parsed = decryptData(encrypted);
      const user_id = parsed.user_id;
      const org_id = parsed.selected_org?.value || parsed.selected_org?.id || null;

      if (!user_id || !org_id) return alert('Invalid session');

      const res = await fetch(SALES_ORDER_SEARCH_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: searchTerm,
          user_id,
          org_id,
          from_date: fromDate,
          to_date: toDate
        })
      });

      const data = await res.json();
      if (res.ok) setResults(data);
      else alert(data.error || 'Failed to fetch orders');
    } catch (err) {
      console.error('Search error:', err);
      alert('Server error');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="card shadow-lg border-0 rounded-4">
          <div
            className="card-header text-white rounded-top-4"
            style={{
              background: 'linear-gradient(270deg,rgb(255, 94, 0), #0056b3)',
              padding: '1rem 1.5rem'
            }}
          >
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
              <div>
                <h4 className="mb-0">Sales Orders</h4>
                <small className="text-white-50">Search by customer name, order number, or date range</small>
              </div>
              <div className="d-flex gap-2 mt-3 mt-md-0">
                <button
                  className="btn btn-light fw-bold"
                  onClick={() => setViewMode(viewMode === 'card' ? 'table' : 'card')}
                >
                  {viewMode === 'card' ? 'Show Table View' : 'Show Card View'}
                </button>
                <button
                  className="btn btn-light text-primary fw-bold"
                  onClick={() => navigate('/so/new')}
                >
                  + Add New Sales Order
                </button>
              </div>
            </div>
          </div>

          <div className="card-body p-4">
            <div className="row g-3 mb-4">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by customer name or order no"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button className="btn btn-primary w-100" onClick={handleSearch}>
                  Search / Refresh
                </button>
              </div>
            </div>

            {results.length === 0 ? (
              <div className="text-muted">No results found.</div>
            ) : viewMode === 'card' ? (
              results.map((order) => (
                <SalesOrderCard
                  key={order.id}
                  order={order}
                  setOrder={(updatedOrder) =>
                    setResults((prev) =>
                      prev.map((o) => (o.id === updatedOrder.id ? updatedOrder : o))
                    )
                  }
                />
              ))
            ) : (
              <SalesOrderTable
                orders={results}
                setOrders={setResults}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesOrderSearch;
